import { defineComponent as _defineComponent } from 'vue'
import {
  AmountType,
  FundingType,
  Trade,
  activeMarginTradeStates,
  formatHedgingInstrument,
  fundingTypesToHuman,
  getCcyByAmountType,
  getCurrencyPair,
  getPrimaryCcy,
  tradeStatusBadges,
} from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { SIMPLE_DATE_FORMAT, formatDate } from 'ah-common-lib/src/helpers/time';
import { PropType, computed } from 'vue';
import { useAuthStore } from 'bd-common/src/store/authStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeDetails',
  props: {
  trade: {
    type: Object as PropType<Trade>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const authStore = useAuthStore();

const tradeCurrencyPair = computed(() => getCurrencyPair(props.trade));

const getProductRate = computed(() => getPrimaryCcy(props.trade).clientRate);

const buyCCY = computed(() => getCcyByAmountType(props.trade, AmountType.BUY));

const sellCCY = computed(() => getCcyByAmountType(props.trade, AmountType.SELL));

const tradeStatus = computed(() => tradeStatusBadges[props.trade.status]?.label);

const gbpVariationMargin = computed(() => {
  return props.trade.gbpVmm ?? 0;
});

const tradeMarginIsActive = computed(() => {
  return activeMarginTradeStates.includes(props.trade.state);
});

const gbpInitialMarginValue = computed(() => {
  return props.trade.gbpInitialMarginAmount ?? 0;
});

const gbpInUseMarginValue = computed(() => {
  if (!tradeMarginIsActive.value) {
    return 0;
  }
  return gbpVariationMargin.value + gbpInitialMarginValue.value;
});

const bankName = computed(() => authStore.loggedInIdentity?.partner.name);

return { __sfc: true,props, authStore, tradeCurrencyPair, getProductRate, buyCCY, sellCCY, tradeStatus, gbpVariationMargin, tradeMarginIsActive, gbpInitialMarginValue, gbpInUseMarginValue, bankName, FundingType, formatHedgingInstrument, fundingTypesToHuman, formatCurrencyValue, SIMPLE_DATE_FORMAT, formatDate }
}

})